import { httpRequest } from "@services/http";

export class CommandChangePasswordExternal {
    async run(token: string, userId: string | number, password: string) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/auth/password-verify/`;
        const body = {
            token: token,
            user_id: userId,
            password: password
        };
        const response = await httpRequest(url, { method: "POST", body });
        return response;
    }
}